import styled from 'styled-components';

export const Container = styled.div`
  margin: ${({ theme }) => theme.spacing.ms};
  text-align: center;
`;

export const DateText = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
`;
